import Navigationbar from "../Navigationbar";
import React, {useMemo, useState} from "react";
import { useParams} from "react-router-dom";
import {Alert, Button, Form, Modal, OverlayTrigger, Tooltip} from "react-bootstrap";
import {faArrowLeft, faArrowRight, faPaperPlane, faSpinner} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useAuth} from "../../authprovider";


export default function CalendarView(props){

    const {calendar} = useAuth()
    const [eventModal, setEventModal] = useState({show:false, event:undefined})

    const [date, setDate] = useState(()=>{
        const localDate = null
        const currentDate = new Date();
        if(localDate){
            currentDate.setTime(Date.parse(localDate));
        }

        return currentDate;
    });
    const [events, setEvents] = useState([])

    const header = ['Pn', "Wt", "Śr", "Czw", "Pt", "Sb", "Nd"]
    const monthNames = ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień","Październik", "Listopad","Grudzień"]

    const loadEventsCallback = ({success, content})=>{
        setEvents(content)
    }

    const days = useMemo(()=>{
        const currentDate = new Date(date)
        currentDate.setDate(1)
        const result = [];
        let dayOfWeek = currentDate.getDay()
        const currentMonth = currentDate.getMonth()
        const currentYear = currentDate.getFullYear()

        if(dayOfWeek === 0)
            dayOfWeek = 7

        currentDate.setDate(currentDate.getDate() + (1-dayOfWeek))

        for(let week = 0; week < 6; week++)
            for(let i =0; i < 7; i++){

                result.push(
                    {
                        date:currentDate.toLocaleDateString(),
                        day:currentDate.getDay() === 0 ? 7 : currentDate.getDay(),
                        currentMonth: currentDate.getMonth() === currentMonth
                    }
                )
                currentDate.setDate(currentDate.getDate()+1)
            }

        calendar.select(result[0].date, result[result.length-1].date, loadEventsCallback )

        return result

    }, [date])


    const changeMonth = (num)=>{
        date.setMonth(date.getMonth()+num)
        setDate(new Date(date))
    }

    const hideEventModal = (event)=>{
        setEventModal({show: false, event: undefined})

        if(!event) return;


        setEvents((prev)=>{
            let d = prev.filter(e=>e.id !== event.id)
                d.push({...event, date:event.date.split('-').reverse().join('.')})

            return d
        })
    }

    const handleEditEvent = (event)=>{
        setEventModal({show: true, event: event})
    }

    const hideModalAndRemoveEvent = (event)=>{
        setEventModal({show: false, event: undefined})

        if(!event) return;

        setEvents((prev)=>{
           return prev.filter(e=>e.id !== event.id)
        })
    }


    return (
        <>
            <div className={"h-100 calendar-box"}>
                <div className={"text-center text-white d-flex justify-content-between"}>
                    <Button name={"Poprzedni miesiąc"} variant={"outline-light"} className={"me-4"} onClick={()=>changeMonth(-1)}><FontAwesomeIcon icon={faArrowLeft} /></Button>
                    <span>
                        <span className={"fs-5"}>{monthNames[date.getMonth()]}</span>
                        <br/>
                        {date.getFullYear()}
                    </span>

                    <Button  name={"Następny miesiąc"} variant={"outline-light"} className={"ms-4"} onClick={()=>changeMonth(1)}><FontAwesomeIcon icon={faArrowRight} /></Button>
                </div>
                <div className={"calendar"}>

                    {
                        header.map(h=> <div key={`header-${h}`} className={"calendarDay calendarHeader"}>{h}</div>)
                    }
                    {
                        days && events && days.map((day, index)=>
                            <CalendarDay key={index} day={day} events={events} onClick={handleEditEvent} />
                        )
                    }
                </div>
                <div className={"mt-3"}>
                    <Button name={"Dodaj przegląd"} variant={"outline-warning "} className={""} onClick={()=>setEventModal({show: true, event: undefined})}>Dodaj</Button>
                </div>

            </div>
            {
                eventModal.show && <AddEditEventModal show={true} event={eventModal.event} onHide={hideEventModal} onDelete={hideModalAndRemoveEvent} />
            }
            <IncomingEventsAlert events={events} />
        </>

    )
}

function CalendarDay({day, events, onClick}){

    const currentMonth = day.currentMonth ? "activeMonth": ""

    const dayEvents = events.filter(event => event.date === day.date)

    const currentDay = new Date().toLocaleDateString() === day.date ? "today":""

    const eventState = ()=>{

        const diff =  (new Date(day.date.split('.').reverse().join('-')).getTime() - new Date().getTime())/1000
        const warning = 60*60*24*14 //14 dni
        const danger = 60*60*24*3 // 3 dni

        if(diff < danger)
            return 'inDanger'
        else if(diff < warning)
            return 'incoming'

        return ''
    }

    return (
        <div key={day.date} className={`calendarDay ${currentDay} ${currentMonth}`} >
            <div className={'calendarDayLabel'}>{day.date.split('.')[0]}</div>
            {
                dayEvents && dayEvents.map(event=>
                    <OverlayTrigger
                        key={event.id}
                        placement={"top"}
                        overlay={
                            <Tooltip id={`tooltip-${event.id}`}>
                                {event.name}
                            </Tooltip>
                        }
                    >
                        <div className={`event ${eventState()} `} onClick={()=>onClick(event)} ></div>
                    </OverlayTrigger>
                )
            }
        </div>
    )
}

function IncomingEventsAlert({events}){
    const [show, setShow] = useState(false)
    const incomingEvents = useMemo(()=>{
        const currentDate = new Date().toLocaleDateString().split('.').reverse().join('-')
        const result = []
        const warning = 60*60*24*14 //14 dni
        const danger = 60*60*24*3 // 3 dni
        events.forEach(event=>{
            const diff =  (new Date(event.date.split('.').reverse().join('-')).getTime() - new Date(currentDate).getTime())/1000

            console.log(diff)

            if(diff < 0) return

            if(diff < danger){
                result.push({level:'danger', event: event})
            } else if(diff < warning){
                result.push({level:'warning', event: event})
            }
        })

        if(result.length > 0) setShow(true)

        return result
    }, [events])


    return (
        <Modal
            show={show}
            onHide={()=>setShow(false)}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Zblizające się przeglądy
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>

                {
                    incomingEvents && incomingEvents.map(({level, event})=>{
                        return <Alert variant={level} >
                            <Alert.Heading>{event.date}</Alert.Heading>
                            <h5>{event.name}</h5>
                            <p>
                                {event.description}
                            </p>
                        </Alert>
                    })
                }

            </Modal.Body>

            <Modal.Footer className={"d-flex justify-content-between"}>

                <Button variant={"secondary"} name={"Rozumiem"} onClick={()=>setShow(false)}>Rozumiem</Button>

            </Modal.Footer>
        </Modal>
    )
}

function AddEditEventModal(props){
    const {calendar} = useAuth();
    const [event, setEvent] = useState(()=>{

        if(props.event)
            return {...props.event, date : props.event.date.split('.').reverse().join('-')}

        let d = new Date().toLocaleDateString().split('.')
        return {
            name:"",
            description:"",
            date:`${d[2]}-${d[1]}-${d[0]}`,
            repeat:0
        }
    })
    const [sending, setSending] = useState(false)
    const [error, setError] = useState({show:false, info: ""})

    const handleChange = (e)=>{
        let key = e.target.name
        let value = e.target.value

        setEvent({...event, [key]:value})
    }

    const handleSubmit = ()=>{
        if(!event.date || event.date.length <=0)
            return setError({show: true, info: "Nie wprowadzono daty"})

        if(!event.name || event.name.length <=0)
            return setError({show: true, info: "Nie wprowadzono nazwy wydarzenia"})

        hideAlert()
        setSending(true)

        calendar.save(event, ({success, content, error})=>{

            setSending(false)

            if(success)
                return props.onHide(content)

            return setError({show: true, info : error})
        })

    }

    const handleDelete = ()=>{
        const confirmation = window.confirm("Proszę potwierdzić usunięcie przeglądu z kalendarza");

        if(!confirmation)
            return

        hideAlert()
        setSending(true)

        calendar.remove(event, ({success, content, error})=>{
            setSending(false)

            if(success)
                return props.onDelete(content)

            return setError({show: true, info : error})
        })
    }

    const hideAlert = ()=>{setError({show: false, info: ""})}

    const handleFocus = (event)=>{
        try {
            event.target.showPicker()
        }catch (_){}
    }

    return (
        <Modal
            show={props.show}
            onHide={()=>{props.onHide()}}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Przegląd
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <Form.Label htmlFor="inputName">Nazwa </Form.Label>
                        <div className={"ps-4"}>
                            <Form.Control
                                name="name"
                                type="text"
                                id="inputName"
                                value={event.name}
                                onChange={handleChange}
                                aria-describedby="name"
                            />
                            <Form.Text id="nameDescription" muted>
                                krótka nazwa wydarzenia
                            </Form.Text>
                        </div>
                    </div>
                    <div>
                        <Form.Label htmlFor="inputDescription">Opis </Form.Label>
                        <div className={"ps-4"}>
                            <Form.Control
                                name="description"
                                as={"textarea"}
                                id="inputDescription"
                                value={event.description}
                                onChange={handleChange}
                                aria-describedby="description"
                            />
                            <Form.Text id="descriptionHelpBlock" muted>
                                Wpisz opis przeglądu, wydarzenia
                            </Form.Text>
                        </div>
                    </div>
                    <div>
                        <Form.Label htmlFor="inputDate">Data </Form.Label>
                        <div className={"ps-4"}>
                            <Form.Control
                                name="date"
                                type="date"
                                value={event.date}
                                onChange={handleChange}
                                onFocus={handleFocus}
                                id="inputDate"
                                aria-describedby="data"
                            />
                        </div>
                    </div>
                    <div>
                        <Form.Label htmlFor="inputDate">Powtarzanie </Form.Label>
                        <div className={"ps-4"}>
                            <Form.Select
                                name={"repeat"}
                                aria-label="Default select example"
                                value={event.repeat}
                                onChange={handleChange}
                            >
                                <option value={0}>nie powtarza się</option>
                                <option value={1}>co miesiąc</option>
                                <option value={3}>kwartalnie</option>
                                <option value={6}>półrocznie</option>
                                <option value={12}>co roku</option>
                                <option value={24}>co dwa lata</option>
                                <option value={36}>co trzy lata</option>
                                <option value={60}>co pięc lat</option>
                            </Form.Select>
                        </div>
                    </div>
                    <Alert show={error.show} variant={"warning"} onClose={hideAlert} dismissible>
                        <p>
                            {error.info}
                        </p>
                    </Alert>
                </Modal.Body>

                <Modal.Footer className={"d-flex justify-content-between"}>

                    <Button variant={"secondary"} onClick={()=>{props.onHide()}} name={"Anuluj"}>Anuluj</Button>
                    { sending ?
                        <Button  type={"submit"} variant={"success"} name={"Proszę czekkać"} ><FontAwesomeIcon icon={faSpinner}  spin/></Button>
                        :
                        <div>
                            <Button className={"me-2"} type={"submit"} variant={"success"} onClick={handleSubmit} name={"Zapisz"} >Zapisz</Button>
                            {
                                event.id && <Button  type={"button"} variant={"danger"} onClick={handleDelete} name={"Usuń"} >Usuń</Button>
                            }

                        </div>

                    }

                </Modal.Footer>
        </Modal>
    )
}